import React from 'react';

export const Card = ({ children, className = '', dark = false, ...props }) => {
  return (
    <div 
      className={`rounded-3xl p-6 shadow-sm ${dark ? 'bg-brand text-white' : 'bg-white text-gray-800'} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};